export default {
  title: "Досие на пациент",
  systemIdTooltip: "Системски број на пациентот",
  copySystemId: "Копирај системски број",
  actions: {
    refresh: "Освежи",
  },
  tabs: {
    visits: "Визити",
    tests: "Испитувања",
  },
  visits: {
    empty: "Нема пронајдени визити за овој пациент.",
    emptySubtitle: "Нема забележани визити за овој пациент.",
    idTooltip: "Идентификатор на визита",
    dateTooltip: "Датум и време на визита",
  },
  tests: {
    empty: "Нема пронајдени испитувања за овој пациент.",
    emptySubtitle: "Нема забележани испитувања за овој пациент.",
    viewHistory: "Преглед на историја",
    dateTooltip: "Датум и време на последниот резултат",
  },
  errors: {
    patientNotFound: "Пациентот не е пронајден",
    failedToLoad: "Грешка при вчитување на податоците на пациентот",
    // Patient info card error states
    patientServerTitle: "Нешто тргна наопаку",
    patientServerSubtitle: "Грешка при вчитување на податоците на пациентот. Обидете се повторно.",
    patientNetworkTitle: "Изгубена врска",
    patientNetworkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
    patientTimeoutTitle: "Истече времето за чекање",
    patientTimeoutSubtitle: "Серверот одговара премногу бавно. Обидете се повторно.",
    patientAuthTitle: "Сесијата истече",
    patientAuthSubtitle: "Ве молиме, најавете се повторно за да продолжите.",
    patientUnknownTitle: "Неочекувана грешка",
    patientUnknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    // Visits table error states
    visitsServerTitle: "Нешто тргна наопаку",
    visitsServerSubtitle: "Грешка при вчитување на визитите. Обидете се повторно.",
    visitsNetworkTitle: "Изгубена врска",
    visitsNetworkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
    visitsTimeoutTitle: "Истече времето за чекање",
    visitsTimeoutSubtitle: "Серверот одговара премногу бавно. Обидете се повторно.",
    visitsAuthTitle: "Сесијата истече",
    visitsAuthSubtitle: "Ве молиме, најавете се повторно за да продолжите.",
    visitsUnknownTitle: "Неочекувана грешка",
    visitsUnknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    // Tests table error states
    testsServerTitle: "Нешто тргна наопаку",
    testsServerSubtitle: "Грешка при вчитување на испитувањата. Обидете се повторно.",
    testsNetworkTitle: "Изгубена врска",
    testsNetworkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
    testsTimeoutTitle: "Истече времето за чекање",
    testsTimeoutSubtitle: "Серверот одговара премногу бавно. Обидете се повторно.",
    testsAuthTitle: "Сесијата истече",
    testsAuthSubtitle: "Ве молиме, најавете се повторно за да продолжите.",
    testsUnknownTitle: "Неочекувана грешка",
    testsUnknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    retry: "Повторен обид",
    login: "Најава",
  },
};
